module.exports = __webpack_public_path__ + "media/images/lp/achievement6-sp-4ef3991f76f72ab5a2b049b909e0fdb7.png";